import ExperimentsPage from './ExperimentsPage';

export default ExperimentsPage;
